import { render, staticRenderFns } from "./ChecklistCustomsV2.vue?vue&type=template&id=8d9f85d6"
import script from "./ChecklistCustomsV2.vue?vue&type=script&lang=js"
export * from "./ChecklistCustomsV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports